import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { HeaderBlockSlice } from '../../../../types';
import * as S from './styles';

type Props = { noMargins?: boolean } & Pick<
  HeaderBlockSlice,
  'title' | 'pagination'
>;

function HeaderBlock({ title, pagination, noMargins = false }: Props) {
  const { t } = useAppContext();
  const titleWithPagination =
    pagination && pagination.currentPage > 1
      ? t('category', 'product-collection.paginated-title', {
          ...pagination,
          title,
        })
      : title;
  return (
    <S.Header $noMargins={noMargins} data-test="HeaderText">
      <S.Title $noMargins={noMargins}>{titleWithPagination}</S.Title>
    </S.Header>
  );
}

export default HeaderBlock;
